import { useEffect, useState } from 'react';
import fetchDataUtil, { BackendData } from '../utils/fetchData';

interface UseClientDataResult {
  data: BackendData | null;
  isReady: boolean;
  isFetchInProgress: boolean;
  error: Error | null;
  layout: string | null;
  setLayout: (layout: string | null) => void;
  triggerFetch: () => void;
  clearError: () => void;
}

export function useClientData(configID?: string | null, componentID?: string | null): UseClientDataResult {
  const [layout, setLayout] = useState<string | null>(null);
  const [isReady, setReady] = useState(false);
  const [isFetchInProgress, setFetchInProgress] = useState(false);
  const [data, setData] = useState<BackendData | null>(null);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (layout && data) {
      setReady(true);
    }
  }, [layout, data]);

  const triggerFetch = () => {
    if (!data && !isFetchInProgress && configID) {
      setLayout('single');
      setFetchInProgress(true);
      setError(null); // Clear any previous errors
      fetchDataUtil(configID, componentID || undefined)
        .then((fetchedData) => {
          setData(fetchedData);
          setReady(true);
          setFetchInProgress(false);
          setError(null); // Clear error on success
        })
        .catch((err) => {
          console.error('Error fetching data:', err);
          const errorMessage = err instanceof Error
            ? err
            : new Error(err?.message || 'Failed to fetch application data. Please try again.');
          setError(errorMessage);
          setFetchInProgress(false);
        });
    }
  };

  const clearError = () => {
    setError(null);
  };

  return {
    data,
    isReady,
    isFetchInProgress,
    error,
    layout,
    setLayout,
    triggerFetch,
    clearError
  };
}

